if (!customElements.get("media-gallery")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        Shopify.designMode ? setTimeout(() => this.init(), 200) : this.init();
    }
    init() {
      this.setAttribute("loading", ""),
        (this.section = this.closest(".js-product")),
        (this.variantPicker = this.section.querySelector("variant-picker")),
        (this.mediaGroupingEnabled =
          this.variantPicker &&
          this.hasAttribute("data-media-grouping-enabled") &&
          this.getMediaGroupData()),
        (this.viewer = this.querySelector(".media-viewer")),
        (this.thumbs = this.querySelector(".media-thumbs")),
        (this.controls = this.querySelector(".media-ctrl")),
        (this.prevBtn = this.querySelector('.media-ctrl__btn[name="prev"]')),
        (this.nextBtn = this.querySelector('.media-ctrl__btn[name="next"]')),
        (this.counterCurrent = this.querySelector(".media-ctrl__current-item")),
        (this.counterTotal = this.querySelector(".media-ctrl__total-items")),
        (this.liveRegion = this.querySelector(".media-gallery__status")),
        this.hasAttribute("data-zoom-enabled") &&
          (this.galleryModal = this.querySelector(
            ".js-media-zoom-template"
          ).content.firstElementChild.cloneNode(!0)),
        (this.xrButton = this.querySelector(".media-xr-button")),
        this.mediaGroupingEnabled &&
          ((this.mediaLists = [
            this.viewer.querySelectorAll(".media-viewer__item"),
          ]),
          this.thumbs &&
            this.mediaLists.push(
              this.thumbs.querySelectorAll(".media-thumbs__item")
            ),
          this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors())),
        "stacked" === this.dataset.layout && theme.mediaMatches.md
          ? ((this.resizeInitHandler = this.initGallery.bind(this)),
            window.addEventListener(
              "on:debounced-resize",
              this.resizeInitHandler
            ))
          : this.initGallery(),
        this.section.addEventListener(
          "on:variant:change",
          this.onVariantChange.bind(this)
        ),
        this.removeAttribute("loading"),
        this.setAttribute("loaded", "");
    }
    initGallery(e) {
      if ((this.setVisibleItems(), this.visibleItems.length <= 1)) return;
      this.initialised = !0;
      let t = this.querySelector(".media-viewer__item.is-active");
      t && (this.viewer.scrollLeft = t.offsetLeft),
        (this.viewerItemOffset =
          this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft),
        t
          ? this.setActiveMedia(t, !1)
          : ((this.currentIndex = Math.round(
              this.viewer.scrollLeft / this.viewerItemOffset
            )),
            (this.currentItem = this.visibleItems[this.currentIndex]),
            this.thumbs &&
              (this.currentThumb = this.thumbs.querySelector(
                `[data-media-id="${this.currentItem.dataset.mediaId}"]`
              ))),
        this.addListeners(),
        e &&
          "on:debounced-resize" === e.type &&
          window.removeEventListener(
            "on:debounced-resize",
            this.resizeInitHandler
          );
    }
    addListeners() {
      this.viewer.addEventListener(
        "scroll",
        window.debounce(this.handleScroll.bind(this), 200)
      ),
        this.controls &&
          this.controls.addEventListener(
            "click",
            this.handleNavClick.bind(this)
          ),
        this.thumbs &&
          this.thumbs.addEventListener(
            "click",
            this.handleThumbClick.bind(this)
          ),
        window.addEventListener(
          "on:debounced-resize",
          this.handleResize.bind(this)
        );
    }
    handleScroll() {
      let e = Math.round(this.viewer.scrollLeft / this.viewerItemOffset);
      if (e !== this.currentIndex) {
        let t =
          this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft;
        t === this.viewerItemOffset &&
          this.setActiveMedia(this.visibleItems[e], !1, !0);
      }
    }
    handleNavClick(e) {
      if (!e.target.matches(".media-ctrl__btn")) return;
      let t =
        e.target === this.nextBtn
          ? this.visibleItems[this.currentIndex + 1]
          : this.visibleItems[this.currentIndex - 1];
      this.viewer.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
    }
    handleThumbClick(e) {
      let t = e.target.closest("[data-media-id]");
      if (!t) return;
      let i = this.querySelector(`[data-media-id="${t.dataset.mediaId}"]`);
      this.setActiveMedia(i, !0, !0);
    }
    handleResize() {
      (this.viewerItemOffset =
        this.visibleItems[1].offsetLeft - this.visibleItems[0].offsetLeft),
        this.thumbs && this.checkThumbVisibilty(this.currentThumb);
    }
    setActiveMedia(t, i = !0, s = !1) {
      t !== this.currentItem &&
        (window.pauseAllMedia(this),
        (this.currentItem = t),
        (this.currentIndex = this.visibleItems.indexOf(this.currentItem)),
        ("stacked" === this.dataset.layout && theme.mediaMatches.md) ||
          (i && this.viewer.scrollTo({ left: this.currentItem.offsetLeft }),
          this.thumbs && this.setActiveThumb(),
          this.controls &&
            (this.prevBtn && (this.prevBtn.disabled = 0 === this.currentIndex),
            this.nextBtn &&
              (this.nextBtn.disabled =
                this.currentIndex === this.visibleItems.length - 1),
            this.counterCurrent &&
              (this.counterCurrent.textContent = this.currentIndex + 1)),
          s && e.playActiveMedia(t),
          this.xrButton &&
            "model" === t.dataset.mediaType &&
            (this.xrButton.dataset.shopifyModel3dId = t.dataset.mediaId),
          this.announceLiveRegion(this.currentItem, this.currentIndex + 1)));
    }
    setActiveThumb() {
      this.currentThumb = this.thumbs.querySelector(
        `[data-media-id="${this.currentItem.dataset.mediaId}"]`
      );
      let e = this.currentThumb.querySelector("button");
      this.thumbs.querySelectorAll(".media-thumbs__btn").forEach((e) => {
        e.classList.remove("is-active"), e.removeAttribute("aria-current");
      }),
        e.classList.add("is-active"),
        e.setAttribute("aria-current", "true"),
        this.checkThumbVisibilty(this.currentThumb);
    }
    setVisibleItems() {
      (this.viewerItems = this.querySelectorAll(".media-viewer__item")),
        (this.visibleItems = Array.from(this.viewerItems).filter(
          (e) => e.clientWidth > 0
        )),
        this.counterTotal &&
          (this.counterTotal.textContent = this.visibleItems.length),
        this.controls &&
          (this.controls.dataset.totalItems = this.visibleItems.length);
    }
    checkThumbVisibilty(e) {
      let t = this.thumbs.scrollLeft,
        i = this.thumbs.clientWidth + t,
        s = e.offsetLeft;
      (s + e.clientWidth > i || s < t) &&
        this.thumbs.scrollTo({ left: s, behavior: "smooth" });
    }
    onVariantChange(e) {
      if (
        (this.mediaGroupingEnabled &&
          this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors(e)),
        this.viewerItems)
      ) {
        if (e.detail.variant && e.detail.variant.featured_media) {
          let t = e.detail.variant.featured_media.id.toString(),
            i = Array.from(this.viewerItems).find(
              (e) => e.dataset.mediaId === t
            );
          this.setActiveMedia(i, !0);
        } else if (this.mediaGroupChanged) {
          let s = this.querySelector(".media-thumbs__item:not([hidden])");
          if (s) {
            let { mediaId: r } = s.dataset,
              a = Array.from(this.viewerItems).find(
                (e) => e.dataset.mediaId === r
              );
            this.setActiveMedia(a, !0);
          }
        }
      }
    }
    getMediaGroupFromOptionSelectors(e) {
      return e
        ? e.detail.selectedOptions[this.getMediaGroupData().groupOptionIndex]
        : this.getSelectedOptions()[this.getMediaGroupData().groupOptionIndex];
    }
    getMediaGroupData() {
      if (void 0 === this.variantMediaData) {
        let e = this.querySelector(".js-data-variant-media");
        this.variantMediaData = !!e && JSON.parse(e.textContent);
      }
      return this.variantMediaData;
    }
    setActiveMediaGroup(e) {
      if (
        ((this.mediaGroupChanged = this.currentMediaGroup !== e),
        (this.currentMediaGroup = e),
        !this.mediaGroupChanged)
      )
        return;
      let t = () => {
        this.mediaLists.forEach((e) => {
          e.forEach((e) => {
            e.hidden = !1;
          });
        }),
          this.setVisibleItems();
      };
      if (!e) {
        t(), this.initialised || this.initGallery();
        return;
      }
      let i = this.getMediaGroupData();
      this.mediaLists.forEach((s) => {
        let r = !1;
        if (
          (s.forEach((t) => {
            let s = i.media[t.dataset.mediaId].group,
              a = s === e || !0 === s;
            (t.hidden = !a), a && (r = !0);
          }),
          r
            ? ([...s].forEach((e) => {
                !0 === i.media[e.dataset.mediaId].group &&
                  ("start" === i.media[e.dataset.mediaId].position
                    ? e.parentElement.prepend(e)
                    : e.parentElement.append(e));
              }),
              [...s]
                .filter((e) => e.hidden)
                .forEach((e) => e.parentElement.append(e)))
            : t(),
          s.length > 0)
        ) {
          let a = s[0].closest("carousel-slider");
          a && a.offsetParent && a.refresh();
        }
      }),
        (this.currentItem = null),
        this.setVisibleItems(),
        this.initialised || this.initGallery();
    }
    getSelectedOptions() {
      let e = [];
      return (
        this.variantPicker.querySelectorAll(".option-selector").forEach((t) => {
          "dropdown" === t.dataset.selectorType
            ? e.push(t.querySelector(".custom-select__btn").textContent.trim())
            : e.push(t.querySelector("input:checked").value);
        }),
        e
      );
    }
    announceLiveRegion(e, t) {
      let i = e.querySelector(".media-viewer img");
      i &&
        (this.liveRegion.setAttribute("aria-hidden", "false"),
        (this.liveRegion.innerHTML = theme.strings.imageAvailable.replace(
          "[index]",
          t
        )),
        setTimeout(() => {
          this.liveRegion.setAttribute("aria-hidden", "true");
        }, 2e3));
    }
    static playActiveMedia(e) {
      window.pauseAllMedia();
      let t = e.querySelector("deferred-media");
      t && t.loadContent();
    }
  }
  customElements.define("media-gallery", e);
}
